//#region Props

import { Contract } from "../../../../models/Entities/Contracts/Contract";
import { ContractAddendum } from "../../../../models/Entities/Contracts/ContractAddendum";
import { ErrorType } from "../../../../models/HttpError";
import { AppState } from "../../../../redux/reducers";

// stores
import * as ContractsStore from "../../../../redux/middleware/ContractMiddleware";
import * as ContractAddendumsStore from "../../../../redux/middleware/ContractAddendum.Middleware";

interface IProps {
    ContractId: number;
    AddendumId?: number;
    isOpen: boolean;
    onClose: () => void;
}

interface ConnectedProps {
    // loading
    isLoading: boolean;
    isLoadingSuccessfully: boolean | undefined;
    failOnLoading: boolean;
    errorOnLoading: ErrorType | undefined;

    // updating
    isUpdating: boolean;
    isUpdatedSuccessfully: boolean | undefined;
    failOnUpdating: boolean;
    errorOnUpdating: ErrorType | undefined;

    // deleting
    isDeleting: boolean;
    isDeletingSuccessfully: boolean | undefined;
    failOnDeleting: boolean;
    errorOnDeleting: ErrorType | undefined;

    // creating
    isCreatingAddendum: boolean;
    isCreatingAddendumSuccessfully: boolean | undefined;
    failOnCreatingAddendum: boolean;
    errorOnCreatingAddendum: ErrorType | undefined;

    Contract: Contract | undefined;
    CurrentAddendum: ContractAddendum | undefined;
}

interface DispatchProps {
    GetContractById: typeof ContractsStore.actionCreators.GetContractById;
    GetContractAddendumsByContractId: typeof ContractAddendumsStore.actionCreators.GetContractAddendumsByContractId;
    CreateContractAddendum: typeof ContractAddendumsStore.actionCreators.CreateContractAddendum;
    UpdateContractAddendum: typeof ContractAddendumsStore.actionCreators.UpdateContractAddendum;
    DeleteContractAddendum: typeof ContractAddendumsStore.actionCreators.DeleteContractAddendum;
    ResetContractAddendumFormState: typeof ContractAddendumsStore.actionCreators.ResetContractAddendumFormState;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const currentAddendum = ownProps.AddendumId
        ? state.Contract?.list
            ?.find((c) => c.id === ownProps.ContractId)
            ?.addendums
            ?.find((a: ContractAddendum) => a.id === ownProps.AddendumId)
        : undefined;

    return {
        // loading
        isLoading: state.Contract?.isLoadingOne,
        isLoadingSuccessfully: state.Contract?.successLoadingOne,
        failOnLoading: state.Contract?.failOnLoadingOne,
        errorOnLoading: state.Contract?.error,

        // updating
        isUpdating: currentAddendum?.isUpdating || false,
        isUpdatedSuccessfully: currentAddendum?.isUpdatedSuccessfully || undefined,
        failOnUpdating: currentAddendum?.FailUpdating || false,
        errorOnUpdating: currentAddendum?.ErrorUpdating || undefined,

        // deleting
        isDeleting: currentAddendum?.isDeleting,
        isDeletingSuccessfully: currentAddendum?.isDeletingSuccessfully,
        failOnDeleting: currentAddendum?.FailDeleting,
        errorOnDeleting: currentAddendum?.ErrorDeleting,

        // creating
        isCreatingAddendum: state.ContractAddendum?.isAddingNewOne || false,
        isCreatingAddendumSuccessfully: state.ContractAddendum?.successAddingNewOne || undefined,
        failOnCreatingAddendum: state.ContractAddendum?.failOnAddingNewOne || false,
        errorOnCreatingAddendum: state.ContractAddendum?.error || undefined,

        Contract: state.Contract?.list?.find((c) => c.id === ownProps.ContractId),
        CurrentAddendum: currentAddendum,
    };
};

export const mapDispatchToProps = {
    ...ContractsStore.actionCreators,
    ...ContractAddendumsStore.actionCreators,
};

//#endregion Props
